import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchInstitutions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/institution', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianDuties(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician-duty-imports', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianDutyImport(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/physician-duty-imports/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianDutyImportItems(ctx, { id, ...data }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/physician-duty-imports/${id}/items`, { params: data })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
